import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: ${props => {
    if (props.width) return props.width;
    if (props.maxWidth === 'xlg') return '1200px';
    if (props.maxWidth === 'lg') return '1000px';
    if (props.maxWidth === 'md') return '600px';
    if (props.maxWidth === 'sm') return '400px';
    return '500px';
  }};
  max-width: 90vw;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  h2 {
    margin: 0 0 20px 0;
    color: ${COLORS.PRIMARY};
    font-size: 1.25rem;
    font-weight: 600;
    flex-shrink: 0;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
  min-height: 0;
  flex: 1;
`;

export const Field = styled('div')`
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacing?.(3) ?? '24px'};
  &:last-child {
    padding-bottom: 0;
  }
`;

export const Label = styled.label`
  font-weight: 500;
  color: ${COLORS.PRIMARY};
  font-size: 14px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  flex-shrink: 0;
`; 